import { render, staticRenderFns } from "./productBundle.vue?vue&type=template&id=503b16d9&"
import script from "./productBundle.vue?vue&type=script&lang=js&"
export * from "./productBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports